export function CLUSTER_TEMPLATE_INIT(
  nextState,
  { guid, maintenancePolicy, linkedProfiles }
) {
  nextState[guid] = {
    maintenancePolicy,
    initialMaintenancePolicy: maintenancePolicy,
    linkedProfiles,
    initialLinkedProfiles: linkedProfiles,
    loading: true,
  };
}

export function CLUSTER_TEMPLATE_SET_SELECTED_MAINTENANCE_POLICY_GUID(
  nextState,
  { guid, selectedMaintenancePolicyGuid }
) {
  nextState[guid].selectedMaintenancePolicyGuid = selectedMaintenancePolicyGuid;
}

export function CLUSTER_TEMPLATE_SET_LOADING(nextState, { guid, loading }) {
  if (!nextState[guid]) {
    nextState[guid] = {};
  }
  nextState[guid].loading = loading;
}
